
<i :class="classes(n(), [$props.activated, n('--activated')], [$props.small, n('--small')])"><slot /></i>
